/**
 * @generated SignedSource<<de570c33dae117305daf50d2ee354a49>>
 * @relayHash 919f17e57ebf71c5debab36a45003f54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 88d6862d95c61348c47fe261f74e3468320dd8f4de500841af6271cfc509fea8

import type { ConcreteRequest } from 'relay-runtime';
export type EditPageAgentSessionNudgesSubscription$variables = {
  accountId: string;
  cloudId: string;
  workspaceAri: string;
};
export type EditPageAgentSessionNudgesSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly sessionAri: string;
    readonly sessionId: string;
  } | null;
};
export type EditPageAgentSessionNudgesSubscription = {
  response: EditPageAgentSessionNudgesSubscription$data;
  variables: EditPageAgentSessionNudgesSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "ConvoAiInboxSessionChanged",
    "kind": "LinkedField",
    "name": "convoai_onInboxSessionChanged",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "sessionAri"
      },
      {
        "kind": "ScalarField",
        "name": "sessionId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditPageAgentSessionNudgesSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPageAgentSessionNudgesSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "919f17e57ebf71c5debab36a45003f54",
    "id": "88d6862d95c61348c47fe261f74e3468320dd8f4de500841af6271cfc509fea8",
    "metadata": {},
    "name": "EditPageAgentSessionNudgesSubscription",
    "operationKind": "subscription",
    "text": "subscription EditPageAgentSessionNudgesSubscription($accountId:String!,$cloudId:ID!,$workspaceAri:ID!){convoai_onInboxSessionChanged(accountId:$accountId,cloudId:$cloudId,workspaceAri:$workspaceAri)@optIn(to:[\"ConvoAiInboxSessionChanged\"]){sessionAri,sessionId}}"
  }
};
})();

(node as any).hash = "d73acbd5202b2c25fe576455eae00746";

export default node;
